



































































































































































































































































































































































































































































































































































































































































































































































































































import {
  auth,
  Button,
  Icon2,
  InputContainer,
  MDInput,
  SearchableSelect,
} from "@micad/vue-components";

import { getUserDetailsConst } from "@/assets/js/constants";
import {
  computed,
  defineComponent,
  reactive,
  watch,
} from "@vue/composition-api";
import { getUserDetails, getUserProfiles } from "@/data/repos/userDetails";
import router from "@/router";
import { setUserProfiles, userUpdate } from "@/data/repos/userUpdate";
import {
  Application,
  getAppRoles,
  getUserRoles,
  Role,
  setUserRoles,
} from "@/data/repos/rolesList";
import { UserDetails } from "@/data/repos/commonModels";
import { userPasswordUpdate } from "@/data/repos/userPasswordUpdate";
import Vue from "vue";
import { displayRequestStatus, requestWithNotification } from "@/notifications";
import Loading from "@/components/Loading.vue";
import { userDelete } from "@/data/repos/userDelete";
import ModalContainer from "@/components/ModalContainer.vue";
import { getSsoProviders, SsoProvider } from "@/data/repos/ssoEndpoints";
import { getLinks, Link } from "@/data/repos/links";
import { userUnsuspend } from "@/data/repos/userUnsuspend";
import {
  QBtn,
  QChip,
  QDate,
  QIcon,
  QInput,
  QPopupProxy,
  QSelect,
  QTime,
  QToggle,
  QBadge,
} from "quasar";
import moment from "moment";
import { canIUse } from "@/modules/auth";
import config from "@/config";
import { getClientConfigValue } from "@/data/repos/clientConfig";
import IframePopup from "@/components/IframePopup.vue";
import { localeDateFormat, localeDateTimeFormat } from "@/modules/dates";

interface State {
  user: UserDetails;
  editDetails: boolean;
  editPermissions: boolean;
  roles: Role[];
  links: Link[];
  ssoProviders: SsoProvider[];
  directoryOptions: { label: string; value: string }[];
  directorySelection: { label: string; value: string };
  userAppRolesExtended: Application[];
  applications: Application[];
  showChangePasswordDialog: boolean;
  password: Password;
  passwordChangePossible: boolean;
  loaded: boolean;
  isSelf: boolean;
  unsuspendUser: (confirm: boolean) => void;
  showUnsuspendUserDialog: boolean;
  deleteUser: (confirm: boolean) => void;
  showDeleteUserDialog: boolean;
  progress: boolean;
  userProfileOptions: { label: string; value: number }[];
  userProfilesSelected: { label: string; value: number }[];
  showRoles: boolean;
  showProfiles: boolean;
  showHistory: boolean;
  auditTrailEnabled: boolean;
}

interface Password {
  currentPassword: string;
  newPassword: string;
  newPasswordConfirmation: string;
  errorMessage: string;
}

export default defineComponent({
  name: "UserDetails",
  methods: {
    localeDateFormat,
    localeDateTimeFormat,
    config() {
      return config;
    },
    canIUse,
  },
  components: {
    QChip,
    QSelect,
    QToggle,
    QDate,
    QBtn,
    QInput,
    QIcon,
    QTime,
    QPopupProxy,
    ModalContainer,
    Loading,
    Button,
    InputContainer,
    SearchableSelect,
    MDInput,
    Icon2,
    QBadge,
    IframePopup,
  },
  props: { refresh: { default: "" } },
  setup() {
    const getEmptyPassword = () =>
      ({
        currentPassword: "",
        newPassword: "",
        newPasswordConfirmation: "",
        errorMessage: "",
      } as Password);
    const isSelf = () =>
      parseInt(auth.userId || "-1") === parseInt(router.currentRoute.params.id);
    const isEmail = (str: string) => str.search("@") >= 0;

    const validators = reactive({
      userName: [
        (val: string) => !!val || "Username is required",
        (val: string) => val.length < 254 || "Value is too long",
      ],
      firstName: [
        (val: string) => !!val || "First name is required",
        (val: string) => val.length < 1000 || "Value is too long",
      ],
      lastName: [
        (val: string) => !!val || "Last name is required",
        (val: string) => val.length < 1000 || "Value is too long",
      ],
      position: [(val: string) => val.length < 1000 || "Value is too long"],
      organisation: [(val: string) => val.length < 1000 || "Value is too long"],
      email: [(val: string) => val.length <= 256 || "Value is too long"],
      telephoneNumber: [
        (val: string) => val.length < 20 || "Value is too long",
      ],
      extension: [(val: string) => val.length < 8 || "Value is too long"],
      telephone2Number: [
        (val: string) => val.length < 20 || "Value is too long",
      ],
      mobileNumber: [(val: string) => val.length < 20 || "Value is too long"],
      faxNumber: [(val: string) => val.length < 20 || "Value is too long"],
      pictureURL: [(val: string) => val.length < 1000 || "Value is too long"],
      notes: [(val: string) => val.length < 1000 || "Value is too long"],
      address1: [(val: string) => val.length < 1000 || "Value is too long"],
      address2: [(val: string) => val.length < 1000 || "Value is too long"],
      address3: [(val: string) => val.length < 1000 || "Value is too long"],
      town: [(val: string) => val.length < 1000 || "Value is too long"],
      postcode: [(val: string) => val.length < 10 || "Value is too long"],
      country: [(val: string) => val.length < 1000 || "Value is too long"],
    });
    const state: State = reactive({
      user: getUserDetailsConst(),
      editDetails: false,
      editPermissions: false,
      roles: [],
      links: [],
      ssoProviders: [],
      directoryOptions: computed(() => {
        return [
          { label: "Local", value: "local" },
          ...state.ssoProviders.map((p) => ({
            label: p.title,
            value: p.id,
          })),
        ];
      }),
      directorySelection: computed({
        get(): { label: string; value: string } {
          const selected = (state.ssoProviders || []).filter(
            (v) => v.id === state.user.directory
          );
          return selected.length
            ? { label: selected[0].title, value: selected[0].id }
            : { label: "Local", value: "local" };
        },
        set(v: { label: string; value: string }) {
          state.user.directory =
            !v.value || v.value === "local" ? undefined : v.value;
        },
      }),
      userAppRolesExtended: [] as Application[],
      applications: [] as Application[],
      showChangePasswordDialog: false,
      password: getEmptyPassword(),
      passwordChangePossible: computed(
        () => isSelf() || !isEmail(state.user.userName)
      ),
      isSelf: computed(() => isSelf()),
      deleteUser,
      unsuspendUser,
      loaded: false,
      showUnsuspendUserDialog: false,
      showDeleteUserDialog: false,
      progress: false,
      userProfileOptions: [],
      userProfilesSelected: [],
      showRoles: false,
      showProfiles: false,
      showHistory: false,
      auditTrailEnabled: false,
      validators,
      formValid: computed(() => {
        for (const [key, vFuncs] of Object.entries(validators))
          for (const f of vFuncs)
            if (f(String(state.user[key as keyof UserDetails])) !== true)
              return false;
        return true;
      }),
    });

    getClientConfigValue("HIDE_ROLES").then(
      (resp) =>
        (state.showRoles =
          (resp.payload?.value || "").toLocaleLowerCase() !== "y")
    );

    getClientConfigValue("HIDE_USER_PROFILES").then(
      (resp) =>
        (state.showProfiles =
          (resp.payload?.value || "").toLocaleLowerCase() !== "y")
    );

    getClientConfigValue("SHOW_AUDIT_TRAIL").then((resp) => {
      state.auditTrailEnabled = ["y", "yes", "true"].includes(
        (resp.payload?.value || "").toLocaleLowerCase()
      );
    });

    async function unsuspendUser(confirm: boolean) {
      if (!confirm) {
        state.showUnsuspendUserDialog = true;
      } else {
        state.progress = true;
        const resp = await userUnsuspend(state.user.id);
        displayRequestStatus(
          resp,
          "User has been un-suspended",
          "Internal server error."
        );
        await refreshUser();
        state.progress = false;
        state.showUnsuspendUserDialog = false;
      }
    }

    async function deleteUser(confirm: boolean) {
      if (!confirm) {
        state.showDeleteUserDialog = true;
      } else {
        const resp = await userDelete(state.user.id);
        displayRequestStatus(
          resp,
          "User has been deleted",
          "Internal server error."
        );
        await router.push({ name: "Home", params: { refresh: "true" } });
      }
    }

    async function refreshUser() {
      state.user.suspendedDateTime = "";
      const resp = await getUserDetails(
        parseInt(router.currentRoute.params.id || auth.userId || ""),
        false
      );
      displayRequestStatus(resp, "", "Failed to load user details");
      if (resp.ok) {
        Object.assign(state.user, resp.payload);
      }

      state.userProfilesSelected = state.userProfileOptions.filter(
        (v) => v.value in (state.user.userProfileIds || [])
      );
      const parsedExpirationTimestamp = moment(
        state.user.expirationTimestamp
      ).format("YYYY/MM/DD HH:mm");
      state.user.expirationTimestamp =
        parsedExpirationTimestamp !== "Invalid date"
          ? parsedExpirationTimestamp
          : "";

      const userRoles = (await getUserRoles(state.user.id)).payload as Role[];
      state.user.roleIds = userRoles.map((role: Role) => role.id);
    }

    async function updateLinks() {
      const li = await getLinks(state.user.id);
      if (li.ok && li.payload) {
        state.links = li.payload.map((l) => ({
          ...l,
          iconName: "link",
        }));
      }
    }

    setTimeout(async () => {
      await refreshUser();
      await refreshUserProfiles();

      state.ssoProviders = (await getSsoProviders()).payload || [];

      state.applications = (await getAllAppRoles(
        state.user.roleIds as number[]
      )) as Application[];
      state.loaded = true;
      await updateLinks();
    }, 0);

    async function refreshUserProfiles() {
      const userProfiles = await getUserProfiles(true);
      if (userProfiles.ok)
        state.userProfileOptions = (userProfiles.payload || []).map((v) => ({
          label: v.name || "",
          value: v.id || -1,
        }));
      state.userProfilesSelected = [
        ...state.userProfileOptions.filter((opt) =>
          (state.user.userProfileIds || []).includes(opt.value)
        ),
      ];
    }

    async function getAllAppRoles(roleIds: number[] | undefined) {
      const appRoles = (await getAppRoles()).payload as Application[];
      function getSelectedRole(app: Application) {
        let selectedRole = undefined;
        app.roles.forEach((role) => {
          if (roleIds?.includes(role.id))
            selectedRole = { label: role.name, value: role.id };
        });
        return selectedRole;
      }
      return appRoles.map((app) => ({
        ...app,
        value: getSelectedRole(app),
        options: [
          { label: "None", value: -1 },
          ...app.roles.map((role) => ({
            label: role.name,
            value: role.id,
          })),
        ],
      }));
    }

    watch(
      () => state.roles,
      () => {
        state.user.roleIds = state.applications
          .filter((v) => v.value)
          .map((app) => (app.value && app.value.value) || -1);
      }
    );

    function formatDate(d: string | undefined) {
      if (d === undefined) return undefined;
      try {
        return moment(d, "YYYY/MM/DD HH:mm").toDate().toISOString();
      } catch {
        return undefined;
      }
    }

    async function saveDetails() {
      const resp = await userUpdate({
        id: state.user.id,
        userName: state.user.userName.trim(),
        firstName: state.user.firstName.trim(),
        lastName: state.user.lastName.trim(),
        position: state.user.position || undefined,
        organisation: state.user.organisation || undefined,
        email: state.user.email || undefined,
        telephoneNumber: state.user.telephoneNumber || undefined,
        telephone2Number: state.user.telephone2Number || undefined,
        mobileNumber: state.user.mobileNumber || undefined,
        extension: state.user.extension || undefined,
        faxNumber: state.user.faxNumber || undefined,
        micadUser: state.user.micadUser,
        active: state.user.active || false,
        pictureURL: state.user.pictureURL || undefined,
        notes: state.user.notes || undefined,
        address1: state.user.address1 || undefined,
        address2: state.user.address2 || undefined,
        address3: state.user.address3 || undefined,
        town: state.user.town || undefined,
        postcode: state.user.postcode || undefined,
        country: state.user.country || undefined,
        expirationTimestamp: formatDate(state.user.expirationTimestamp),
      });
      displayRequestStatus(
        resp,
        "User details were updated",
        "User details were not updated. Internal server error."
      );
      if (!resp.ok) return;
      const pResp = await setUserProfiles(
        state.user.id,
        state.userProfilesSelected.map((v) => v.value)
      );
      if (pResp.ok) state.editDetails = false;
      router.currentRoute.params.refresh = "true";
    }

    async function saveRoles() {
      state.user.roleIds = state.applications
        .filter((v) => v.value)
        .map((app) => (app.value && app.value.value) || -1)
        .filter((v) => v > 0);
      const resp = await setUserRoles(state.user.id, state.user.roleIds);
      displayRequestStatus(
        resp,
        "User roles were updated",
        "Roles were not saved. Internal server error."
      );
      if (resp.ok) state.editPermissions = false;
      updateLinks();
    }
    const toggleEditDetails = () => (state.editDetails = !state.editDetails);
    const toggleEditPermissions = () =>
      (state.editPermissions = !state.editPermissions);

    async function submitPasswordChange() {
      if (isSelf() && !state.password.currentPassword.length) {
        state.password.errorMessage = "Current password is missing";
        return;
      }
      if (
        state.password.newPassword !== state.password.newPasswordConfirmation
      ) {
        state.password.errorMessage = "Password and confirmation do not match";
        return;
      }
      if (state.password.newPassword.length < 8) {
        state.password.errorMessage = "Password is too short";
        return;
      }
      const resp = await userPasswordUpdate({
        userId: state.user.id,
        currentPassword: state.password.currentPassword,
        newPassword: state.password.newPassword,
      });
      if (resp.ok) {
        Vue.$toast.success("Password has been successfully updated");
      } else {
        const errResp = resp.response;
        if (errResp && errResp.data.errorMessage) {
          state.password.errorMessage = errResp.data.errorMessage;
          return;
        } else {
          state.password.errorMessage =
            "Cannot update password due to server error";
          return;
        }
      }
      state.password = getEmptyPassword();
      state.showChangePasswordDialog = false;
    }

    function cancelPasswordChange() {
      state.password = getEmptyPassword();
      state.showChangePasswordDialog = false;
    }
    return {
      state,
      saveDetails,
      saveRoles,
      toggleEditDetails,
      toggleEditPermissions,
      submitPasswordChange,
      cancelPasswordChange,
      isSelf,
      openLink: (url: string) => window.open(url, "_blank")?.focus(),
      goToCreateUser: () => router.push({ name: "UserCreate" }),
      goBack: () =>
        router.push({
          name: "Home",
          params: { refresh: router.currentRoute.params.refresh },
        }),
    };
  },
});
